// extracted by mini-css-extract-plugin
module.exports = {"fontTheme":"styles_fontTheme__vL5cA"};